module.exports = __webpack_public_path__ + "7e08cc656863d52bcb5cd34805ac605b.ttf";